import { createActions } from 'redux-actions';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from '../../common';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    GET_CPD_CATEGORY_PROGRESS: (userId, query) => ({ userId, query }),
    API: {
      GET_CPD_CATEGORY_PROGRESS: apiResourceActionCreator('cpdCategorys')
    }
  }
})

const defaultQuery = { yearsFromNow: 0 };

export const apiAction = (authToken, query) => {
  const finalQuery = {
    ...defaultQuery,
    ...query,
  }
  return commonApiActions.authenticated.get(
    `${USER_RESOURCE_ENDPOINT(RESOURCES.CpdCategoryProgress)}${endpointQuery(finalQuery)}`,
    authToken, actions.user.api.getCpdCategoryProgress
  )
}

const configuration = {
  name: 'getCpdCategoryProgress',
  action: actions,
  sagas: undefined,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingCpdCategoryProgress: true
    }),
    success: (state, action) => ({
      ...state,
      cpdCategoryProgress: action.payload.cpdCategorys,
      isFetchingCpdCategoryProgress: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetchingCpdCategoryProgress: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getCpdCategoryProgress.js